import {Stoppage} from '@hconnect/common/types'
import {Grid} from '@mui/material'
import {FC, ReactNode, useCallback} from 'react'

import {EventStoppedMainEquipmentSearch} from './EventStoppedMainEquipmentSearch'

type StoppedMainEquipmentContainer = {
  plantId: string
  errorText?: ReactNode
  availableDepartmentCodes?: string[]
  updateMultiPart: (delta: Partial<Stoppage>) => void
  item: Partial<Stoppage>
  disabled?: boolean
}

export const StoppedMainEquipmentContainer: FC<StoppedMainEquipmentContainer> = ({
  plantId,
  item,
  errorText,
  availableDepartmentCodes,
  updateMultiPart,
  disabled
}) => {
  const updateStoppedMainEquipment = useCallback(
    (value?: string) => {
      updateMultiPart({
        upmDepartmentId: value
      })
    },
    [updateMultiPart]
  )

  return item.upmDepartmentId || (!item.upmDepartmentId && availableDepartmentCodes) ? (
    <Grid item xs={12}>
      <EventStoppedMainEquipmentSearch
        plantId={plantId}
        errorText={errorText}
        onChange={updateStoppedMainEquipment}
        value={item.upmDepartmentId}
        required
        availableDepartmentCodes={availableDepartmentCodes}
        disabled={disabled}
      />
    </Grid>
  ) : undefined
}
